<template>
  <perfect-scrollbar ref="ps" class="scrollbar scroll-always-visible" :options="scrollOptions">
    <div class="carts-list">
      <div class="row">
        <div class="col-md-5">
          <h1>
            <i class="icon-favoris_on"></i>
            <span v-translate>Gestion de toutes mes sélections</span>
            [{{ all.length }}]
          </h1>
        </div>
        <div class="col-md-7 carts-bar d-flex justify-content-end align-items-start">
          <a class="btn btn-round" href="" @click.prevent="setupNewCart" v-translate>Créer une nouvelle sélection</a>
          <file-upload
            class="btn btn-round"
            :post-action="uploadUrl"
            :headers="uploadHeaders"
            extensions="csv"
            :multiple="true"
            :size="1024 * 1024 * 10"
            v-model="files"
            @input-file="inputFile"
            ref="upload"
          >
            <span v-translate>Nouvelle sélection par import clés Gcoll2</span>
          </file-upload>
          <a href="" @click.prevent="closeCarts" class="btn btn-round" v-translate>Quitter cette page</a>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <CartExportSummary />
          <CartImportSummary />

          <div class="carts-list-error" v-if="createCartError">
            <strong v-translate>Ce nom de dossier de sélection existe déjà. Choisissez un autre nom.</strong>
          </div>

          <table>
            <thead>
              <tr>
                <th class="header-sort" @click="sort('name')" :class="sortClass('name')">
                  <div class="cart-top-name">
                    <span v-translate style="max-width: 40%; display: block">Nom de la sélection</span>
                  </div>
                </th>
                <th class="header-sort" @click="sort('created_at')" :class="sortClass('created_at')">
                  <div class="cart-top-name">
                    <span v-translate style="max-width: 40%; display: block">Date de création</span>
                  </div>
                </th>
                <th class="header-sort" @click="sort('updated_at')" :class="sortClass('updated_at')">
                  <div class="cart-top-name">
                    <span v-translate style="max-width: 55%; display: block">Date de dernière modification</span>
                  </div>
                </th>
                <th
                  class="header-sort col-length"
                  @click="sort('artwork_ids_length')"
                  :class="sortClass('artwork_ids_length')"
                >
                  <div class="cart-top-name">
                    <span v-translate style="max-width: 40%; display: block">Nombre d'œuvre</span>
                  </div>
                </th>
                <th class="col-length">
                  <div class="cart-top-name">
                    <span v-translate style="max-width: 50%; display: block">Notice associée</span>
                  </div>
                </th>
                <th class="">
                  <div class="cart-top-name">
                    <span v-translate style="max-width: 40%; display: block">Sélection partagée</span>
                  </div>
                </th>
                <th>
                  <div class="cart-top-name" v-translate>Actions</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="row-selected" v-if="isNewCartOpen">
                <td colspan="3">
                  <form @submit.prevent="createCart">
                    <input v-focus v-model="cartName" class="form-control" type="text" :placeholder="titles.name" />
                  </form>
                </td>
                <td colspan="4">
                  <div v-if="createCartError" class="float-left" v-translate>
                    Ce nom de dossier de sélection existe déjà. Choisissez un autre nom.
                  </div>
                  <div class="float-right">
                    <a class="btn btn-outline-secondary" @click.prevent="newCartCancel" v-translate>annuler</a>
                    <button
                      class="btn btn-outline-secondary text-dark"
                      type="submit"
                      @click.prevent="createCart"
                      v-translate
                    >
                      OK
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-for="cart in filteredList" is="cart" :key="cart.id" :cart="cart"></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </perfect-scrollbar>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import Cart from './Cart.vue';
import CartImportSummary from './CartImportSummary.vue';
import CartExportSummary from './CartExportSummary.vue';
import Vue from 'vue';
import FileUpload from 'vue-upload-component';
import { baseUrl, interfaceStrings } from 'config';

export default {
  name: 'Carts',
  components: { Cart, FileUpload, CartImportSummary, CartExportSummary },
  methods: {
    ...mapMutations('carts', ['assign']),
    ...mapActions('carts', ['getAll', 'summary']),
    setupNewCart() {
      this.cartName = '';
      this.assign({ name: 'isNewCartOpen', data: true });
      this.assign({ name: 'selectedCartId', data: null });
    },
    newCartCancel() {
      this.assign({ name: 'isNewCartOpen', data: false });
    },
    createCart() {
      this.$store.dispatch('carts/create', { name: this.cartName });
    },
    closeCarts() {
      this.$router.push({ name: 'Artworks' });
    },
    inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        this.$refs.upload.active = true;
      }

      if (newFile && oldFile && !newFile.active && oldFile.active) {
        if (newFile.xhr && newFile.xhr.status === 201) {
          const cart = newFile.response;
          this.summary({ id: cart.id, type: 'import' });
          this.$store.dispatch('carts/add', cart);
          this.assign({ name: 'selectedCartId', data: cart.id });
          this.assign({ name: 'editCartId', data: null });
        }

        if (newFile.xhr && newFile.xhr.status === 400) {
          this.$toastr('info', this.errorMessage);
        }
      }
    },
    sort: function (s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    sortClass: function (sort) {
      return {
        'sort-asc': this.currentSort === sort && this.currentSortDir === 'asc',
        'sort-desc': this.currentSort === sort && this.currentSortDir === 'desc',
      };
    },
  },
  computed: {
    ...mapGetters('carts', ['all', 'exportSummary', 'importSummary']),
    ...mapState('carts', ['createCartError', 'isNewCartOpen']),
    ...mapState('auth', ['isAuthenticated']),
    errorMessage() {
      const {
        cart: { invalid_import_file_format },
      } = interfaceStrings;
      return invalid_import_file_format[this.lang];
    },
    lang() {
      return this.$language.current;
    },
    uploadUrl() {
      return `${baseUrl}/carts/import`;
    },
    uploadHeaders() {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      return { 'X-Token': token };
    },
    filteredList() {
      let items = this.all;

      items = this.all.slice().sort((a, b) => {
        let modifier = 1;
        const aValue = this.currentSort.split('.').reduce((o, i) => o[i], a);
        const bValue = this.currentSort.split('.').reduce((o, i) => o[i], b);
        if (this.currentSortDir === 'desc') modifier = -1;

        if (typeof aValue === 'string') {
          return aValue.localeCompare(bValue) * modifier;
        }

        if (aValue < bValue) return -1 * modifier;
        if (aValue > bValue) return 1 * modifier;
        return 0;
      });

      return items;
    },
    titles() {
      return {
        send: this.$gettext('Créer une nouvelle sélection'),
      };
    },
  },
  mounted() {
    this.getAll();
    this.assign({ name: 'createCartError', data: false });
  },
  destroyed() {
    this.assign({ name: 'importSummary', data: null });
    this.assign({ name: 'exportSummary', data: null });
  },
  watch: {
    isAuthenticated(newValue, oldValue) {
      if (!newValue) {
        this.$router.push('/');
      }
    },
  },
  data() {
    return {
      cartName: '',
      files: [],
      currentSortDir: 'desc',
      currentSort: 'updated_at',
      scrollOptions: {
        suppressScrollX: true,
      },
    };
  },
};
</script>
